import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Tooltip } from 'src/shared/components/tooltip';
import { Content } from './content';
export function ModuleRadio({ moduleType, isSelected, onSelect, isDisabled, tooltip = '' }) {
    function handleSelect(event) {
        onSelect(event.currentTarget.value);
    }
    return (_jsx(Tooltip, { text: tooltip, className: "ml-2", disabled: !isDisabled, children: _jsxs("label", { className: clsx('transition-smooth group m-0 flex w-[314px] cursor-pointer flex-col items-center rounded-extralarge border-radius p-4 pt-5 hover:shadow-medium active:shadow-small', {
                'border-large border-primary-500 shadow-small': isSelected,
                'border-small border-neutral-200 focus:shadow-small': !isSelected,
                'cursor-auto opacity-50': isDisabled
            }), children: [_jsx("input", { type: "radio", name: "module-type", className: "hidden", value: moduleType, checked: isSelected, disabled: isDisabled, onChange: handleSelect }), _jsx(Content, { isSelected: isSelected, moduleType: moduleType })] }) }));
}
